import InfoIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';

type Props = {
  children: React.ReactNode;
  tooltipText?: string;
};

const HeaderCell = ({ children, tooltipText }: Props) => (
  <TableCell sx={{ position: 'relative', whiteSpace: 'nowrap' }}>
    {children} &nbsp;
    {tooltipText && (
      <Tooltip title={tooltipText}>
        <IconButton
          size="small"
          sx={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          <InfoIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    )}
  </TableCell>
);

export default HeaderCell;
